export default __webpack_public_path__ + "static/media/classy.514cdefc.png";